export const educationData = [
  {
    id: 1,
    institution: "San Jose State University",
    course: "MS | Computer Software Engineering",
    startYear: "Aug 2022",
    endYear: "May 2024",
  },
  {
    id: 2,
    institution: "MIT WPU",
    course: "BTech | Computer Science",
    startYear: "Aug 2017",
    endYear: "Apr 2021",
  },
];
